import { observer } from "mobx-react-lite"
import { store } from "../../../../../stores/Store"
import Panel from "../../../../layout/Panel"
import PanelLabel from "../../../../layout/PanelLabel"
import PanelHeader from "../../../../layout/PanelHeader"
import PanelBody from "../../../../layout/PanelBody"
import { DetailPanelProps } from ".././DetailPanel"
import AutomationSection from "./AutomationSection"
import { Automator } from "../../../../../models/Automator"
import { SelectOption } from "../../../../form/fields/SelectField"
import { AlertModal } from "../../../../.."
import ViewQuestionnaire from "../../../questionnaire/ViewQuestionnaire"
import { Icons } from "../../../../../misc/Icons"
import { Theme } from "../../../../../misc/Theme"
import TruncText from "../../../../../misc/TruncText"



export default observer(function AutomationDetail ({index}: DetailPanelProps) {

    const { leafNode, loadingLeafNode } = store.NodeStore
    
    return (
        <Panel index={index} id="DETAIL" className="detail" width="100%" loadingContent={loadingLeafNode}>

            <PanelLabel title="Details" />
            
            <PanelHeader closeable node={leafNode} onClose={() => store.NodeStore.setLeafNode(null)}>
                {/* <AutomationStatus node={leafNode} /> */}
            </PanelHeader>

            <PanelBody>
                <div className="panel-columns">
                    <div className="panel-column">
                        <AutomationSection automationNode={leafNode} hideOldVersions={true} />
                    </div>
                    
                    <div className="panel-column">
                        <div className="detail-section">
                            <div className="section-header">
                                <div className="header">
                                    <h4>Data sources</h4>
                                </div>
                            </div>
                        
                            {leafNode.enquiry ? (
                                <>
                                    <div className="section-subheader">
                                        <h5>You have an associated Assessment.</h5>
                                    </div>

                                    <div className="section-table" style={{marginBottom: "10px"}}>
                                        <div className="section-row">
                                            <div className="section-cell" style={{width: "auto"}}>
                                                <Icons.Enquiry style={{color: Theme.palette.primary.main}} />
                                            </div>

                                            <div className="section-cell link" style={{width: "auto"}} onClick={() => store.NodeStore.navigateNode(leafNode.enquiry.uid)}>
                                                {leafNode.enquiry.uid.replace("ENQUIRY_", "Assessment ")}
                                            </div>
                                        </div>
                                    </div>    
                                </>
                            ) : (
                                <div className="section-subheader" style={{borderBottom: "none"}}>
                                    <h5>This is a Standalone Application and therefore doesn't have any associated Assessment.</h5>
                                </div>
                            )}

                            <QuestionnairesUsed automators={leafNode.automations} />
                        </div>
                    </div>
                </div>
            </PanelBody>

        </Panel>
    )
})


function QuestionnairesUsed ({automators}) {

    var questionnaireRefs: SelectOption[] = []
    automators.forEach((automator: Automator) => {
        automator.profile?.questionnaires?.forEach((qRef: SelectOption) => {
            var existingRef = questionnaireRefs.find(ref => ref.value === qRef.value)
            if (!existingRef) {
                questionnaireRefs.push(qRef)
            }
        })

        automator.profile?.data_source_refs?.forEach((dsRef) => {
            var existingRef = questionnaireRefs.find(ref => ref.value === dsRef.sourceUid)
            if (!existingRef && !dsRef.sourceUid?.includes("ENQUIRY")) {
                questionnaireRefs.push({value: dsRef.sourceUid, label: dsRef.label})
            }
        })
    })

    return (
        <div className="detail-section">
            <div className="section-subheader">
                <h5>You have used {questionnaireRefs.length} Questionnaires{questionnaireRefs.length === 1 ? "" : "s"} in this Application.</h5>
            </div>

            {questionnaireRefs.map((dsRef: SelectOption, i) => (
                <div key={i} className="section-table" style={{marginBottom: "10px"}}>
                    <div className="section-row">
                        <div className="section-cell" style={{width: "auto"}}>
                            <Icons.Questionnaire color="primary" />
                        </div>

                        <div className="section-cell link" style={{width: "auto"}} onClick={() => {
                            if (dsRef.value?.includes("ENQUIRY")) { 
                                store.NodeStore.navigateNode(dsRef.value)
                            } else {
                                AlertModal({width: "700px", body: <ViewQuestionnaire uid={dsRef.value} />})
                            }
                        }}>
                            <TruncText text={dsRef.label} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}